import http from 'utils/http';
import {
  getAvailableIntegrationsUrl,
  getIntegrationsUrl,
  getIntegrationUrl,
  getIntegrationToolsUrl,
  getNewIntegrationsUrl,
  getOauthRedirectUrl,
  getPostConfigurationFieldUrl,
  getUpdateIntegrationsUrl,
  getCurveDentalOperatoriesUrl,
  getInitialSyncUrl,
  getManualSyncUrl,
  getSynchronizerLogsUrl,
  getSynchronizedItemsUrl
} from './apiUrls';
import {
  AvailableIntegrationResponse,
  IntegrationResponse,
  InitialSyncResponse,
  SynchronizerLogsResponse,
  SynchronizedItemsResponse
} from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getAvailableIntegrations(
  params?: Record<string, any>
): Promise<{ data: AvailableIntegrationResponse[]; meta: MetaApiResponse }> {
  return http.get(getAvailableIntegrationsUrl(), params);
}

export function getNewIntegrationsFields(code: string): Promise<any> {
  return http.get(getNewIntegrationsUrl(), { code });
}

export function getPostConfigurationFields(id?: string): Promise<any> {
  return http.get(getPostConfigurationFieldUrl(id));
}

export function getIntegrations(
  params?: Record<string, any>
): Promise<{ data: IntegrationResponse[]; meta: MetaApiResponse }> {
  return http.get(getIntegrationsUrl(), params);
}

export function getApiErrorMessage(error: any) {
  return error?.response?.data?.error ?? 'An unexpected error occurred';
}

export function createIntegrations(payload: any): Promise<any> {
  return http.post(getIntegrationsUrl(), payload);
}

export function updateIntegrations(integrationId: string, payload: any): Promise<any> {
  return http.put(getUpdateIntegrationsUrl(integrationId), payload);
}

export function createOauthIntegrations(code: string, payload: any): Promise<any> {
  return http.post(getOauthRedirectUrl(code), payload);
}

export function deleteIntegration(id: number): Promise<{ meta: { message: string } }> {
  return http.delete(getIntegrationUrl(id));
}

export function getIntegration(id: number, params?: Record<string, any>): Promise<{ meta: { message: string } }> {
  return http.get(getIntegrationUrl(id), params);
}

export function getIntegrationTools(integrationId: string): Promise<any> {
  return http.get(getIntegrationToolsUrl(integrationId));
}

export function getCurveDentalOperatories(integrationId?: string, providerId?: number): Promise<any> {
  return http.get(getCurveDentalOperatoriesUrl(), { integration_id: integrationId, provider_id: providerId });
}

export function startInitialSync(integrationId: number | string): Promise<InitialSyncResponse> {
  return http.post(getInitialSyncUrl(integrationId));
}

export function manualSync(integrationId: number | string): Promise<InitialSyncResponse> {
  return http.post(getManualSyncUrl(integrationId));
}

export function getSynchronizerLogs(params?: Record<string, any>): Promise<SynchronizerLogsResponse> {
  return http.get(getSynchronizerLogsUrl(), params);
}

export function getSynchronizedItems(
  synchronizerLogId: number | string,
  params?: Record<string, unknown>
): Promise<SynchronizedItemsResponse> {
  return http.get(getSynchronizedItemsUrl(synchronizerLogId), params);
}
